import React, { memo } from 'react';
import classnames from 'classnames';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { SelectCrewPanel } from '../../SelectCrewPanel/SelectCrewPanel';
import { useStyles } from './useStyles';
import { getCurrentSendedTakeOff } from '../../../selectors/sended-data';
import { getCurrentLegCabinCrew } from '../../../selectors/screen';
import { editInformationField } from '../../../actions/take-off';

export const CrewPanel = memo(() => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const pilotFlight = useSelector((state) => {
        const takeOff = getCurrentSendedTakeOff(state);
        const isPilotFlightRequired = get(state, 'routesDeclaration.options.isPilotFlightRequired', false);
        const cabinCrew = getCurrentLegCabinCrew(state);

        return {
            items: cabinCrew,
            value: get(takeOff, 'informationForm.pilotFlight'),
            isRequired: isPilotFlightRequired,
        };
    }, shallowEqual);
    const { t: translate } = useTranslation();

    const handleChangePilotFlight = React.useCallback((value) => {
        dispatch(editInformationField('pilotFlight', value ? value : null));
    }, []);

    return (
        <SelectCrewPanel
            {...pilotFlight}
            title={translate('labels.pilotFlying')}
            onChange={handleChangePilotFlight}
            className={classnames(classes.panel, classes.specialPanel)}
        />
    );
});
